/**
 * Table des matières des articles (.table-des-matieres, générée par inc/tablematiere.php) :
 * scroll doux vers les titres avec décalage du header, surlignage de la section courante,
 * ouverture du groupe <details> actif. Logique reprise telle quelle de l'ancien Main.ts.
 */
UNYC.register('toc', () => {
    const isScrollable = (el) => {
        if (!(el instanceof HTMLElement)) return false;

        const overflowY = window.getComputedStyle(el).overflowY;
        const canScroll = overflowY === 'auto' || overflowY === 'scroll';

        return canScroll && el.scrollHeight > el.clientHeight;
    };

    const getScrollContainer = (fromEl) => {
        const app = document.getElementById('unyc-app');
        if (isScrollable(app)) return app;

        let node = fromEl;
        while (node && node !== document.body && node !== document.documentElement) {
            if (isScrollable(node)) return node;
            node = node.parentElement;
        }

        return window;
    };

    const getScrollTop = (container) => {
        if (container === window) {
            let y = window.pageYOffset || document.documentElement.scrollTop || 0;

            if (!y && document.body) {
                const bodyTop = document.body.getBoundingClientRect().top;
                if (bodyTop < 0) y = Math.round(-bodyTop);
            }

            return y;
        }

        return container.scrollTop;
    };

    const getElementTop = (el, container) => {
        const rect = el.getBoundingClientRect();

        if (container === window) {
            return rect.top + getScrollTop(window);
        }

        return container.scrollTop + (rect.top - container.getBoundingClientRect().top);
    };

    const scrollToY = (container, top) => {
        container.scrollTo({ top, behavior: 'smooth' });
    };

    const escapeIdent = (value) => {
        if (window.CSS && typeof window.CSS.escape === 'function') {
            return window.CSS.escape(value);
        }

        return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
    };

    const getNavHeight = () => parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'), 10) || 92;

    /**
     * Distance sous le haut du conteneur à laquelle un titre devient « courant ». Partagée par
     * le scroll au clic et le scroll-spy pour que les deux restent synchronisés.
     */
    const getScrollOffset = () => getNavHeight() + 24;

    const getSectionRoot = (toc) => toc.closest('.html.has-toc') || document.body;
    const getContentRoot = (sectionRoot) => sectionRoot.querySelector('.editor') || sectionRoot.querySelector('.wysiwyg') || sectionRoot;

    const initScrollSpy = (toc) => {
        const links = UNYC.qsa("a.toc-link[href^='#']", toc);
        if (!links.length) return;

        const linksById = {};
        links.forEach((link) => {
            const id = (link.getAttribute('href') || '').replace(/^#/, '');
            if (id && !linksById[id]) linksById[id] = link;
        });

        const sectionRoot = getSectionRoot(toc);
        const scrollContainer = getScrollContainer(sectionRoot);

        const getVisibleHeadings = () => {
            const flow = [];
            const seen = {};

            getContentRoot(sectionRoot).querySelectorAll('h2[id], h3[id]').forEach((heading) => {
                const id = heading.id;
                if (!id || !linksById[id] || seen[id]) return;
                if (!heading.isConnected || heading.getClientRects().length === 0) return;

                seen[id] = true;
                flow.push({ id, el: heading });
            });

            return flow;
        };

        const clearActive = () => {
            toc.querySelectorAll('.toc-h2, .toc-h3').forEach((li) => li.classList.remove('active'));
            toc.querySelectorAll('details').forEach((details) => details.classList.remove('active-group'));
        };

        const applyActive = (activeId) => {
            links.forEach((link) => {
                const id = (link.getAttribute('href') || '').replace(/^#/, '');
                const li = link.closest('.toc-h2, .toc-h3');
                if (!li || id !== activeId) return;

                li.classList.add('active');

                const details = link.closest('details');
                if (details) {
                    details.classList.add('active-group');
                    if (!details.open) details.open = true;
                }
            });
        };

        const update = () => {
            const flow = getVisibleHeadings();
            if (!flow.length) return;

            // +4px de tolérance : le titre visé par un clic atterrit exactement à getScrollOffset().
            const topTrigger = getScrollTop(scrollContainer) + getScrollOffset() + 4;
            let activeId = flow[0].id;

            flow.forEach((item) => {
                if (getElementTop(item.el, scrollContainer) <= topTrigger) activeId = item.id;
            });

            clearActive();
            applyActive(activeId);
        };

        scrollContainer.addEventListener('scroll', UNYC.throttleFrame(update), { passive: true });
        window.addEventListener('resize', update);
        window.addEventListener('load', update);
        update();
    };

    const initSmoothScroll = (toc) => {
        const sectionRoot = getSectionRoot(toc);
        const contentRoot = getContentRoot(sectionRoot);
        const scrollContainer = getScrollContainer(sectionRoot);

        toc.addEventListener('click', (event) => {
            const link = event.target instanceof Element ? event.target.closest("a.toc-link[href^='#']") : null;
            if (!link) return;

            const targetId = (link.getAttribute('href') || '').replace(/^#/, '');
            const scoped = contentRoot.querySelector(`h2#${escapeIdent(targetId)}, h3#${escapeIdent(targetId)}`);
            const target = scoped || document.getElementById(targetId);
            if (!target) return;

            event.preventDefault();
            scrollToY(scrollContainer, getElementTop(target, scrollContainer) - getScrollOffset());
        });
    };

    UNYC.init('.table-des-matieres', 'toc', (toc) => {
        toc.querySelectorAll('summary .toc-link').forEach((link) => {
            link.addEventListener('click', (event) => event.stopPropagation());
        });

        initScrollSpy(toc);
        initSmoothScroll(toc);
    });
});
